export default "__VITE_PUBLIC_ASSET__fb337a1f__"